module.exports = __webpack_public_path__ + "img/oralTest_sub26.f4fa4bf4.jpg";